import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

//  Material UI Icons
import IconButton from "@mui/material/IconButton";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

// Styles
import useStyles from "./ImageNavigationButtons.styles";

const ImageNavigationPrevious = ({ handleClick, index = 0 }) => {
  const classes = useStyles();
  return (
    <IconButton
      aria-label="Previous Picture"
      className={clsx(classes.backButton, classes.icon)}
      onClick={handleClick}
      id={`previous-photo-button-${index}`}
      size="large"
    >
      <NavigateBeforeIcon fontSize="small" />
    </IconButton>
  );
};

ImageNavigationPrevious.propTypes = {
  handleClick: PropTypes.func.isRequired,
};

export default ImageNavigationPrevious;
